import * as i0 from '@angular/core';
import { Injectable, Component, Input, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';

function LliButtonsComponent_lib_rectangle_button_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "lib-rectangle-button", 1);
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("data", ctx_r0.buttonItem);
} }
function LliButtonsComponent_lib_circle_button_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "lib-circle-button", 1);
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("data", ctx_r1.buttonItem);
} }
function LliButtonsComponent_lib_circle_icon_button_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "lib-circle-icon-button", 1);
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("data", ctx_r2.buttonItem);
} }
function CircleButtonComponent_div_0_a_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "a", 4);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("href", ctx_r1.data.url, ɵngcc0.ɵɵsanitizeUrl)("target", ctx_r1.data.target);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r1.data.text, " ");
} }
function CircleButtonComponent_div_0_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "a");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r3.data.text);
} }
const _c0 = function (a0, a1) { return { "dark": a0, "green": a1 }; };
function CircleButtonComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵtemplate(1, CircleButtonComponent_div_0_a_1_Template, 2, 3, "a", 2);
    ɵngcc0.ɵɵtemplate(2, CircleButtonComponent_div_0_ng_template_2_Template, 2, 1, "ng-template", null, 3, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const _r2 = ɵngcc0.ɵɵreference(3);
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(3, _c0, ctx_r0.data.colorType === "dark", ctx_r0.data.colorType === "green"));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.data.url && ctx_r0.data.target)("ngIfElse", _r2);
} }
function CircleIconButtonComponent_div_0_a_1_img_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "img", 6);
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵproperty("src", ctx_r4.data.icon.src, ɵngcc0.ɵɵsanitizeUrl)("alt", ctx_r4.data.icon.alt);
} }
function CircleIconButtonComponent_div_0_a_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "a", 4);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵtemplate(2, CircleIconButtonComponent_div_0_a_1_img_2_Template, 1, 2, "img", 5);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("href", ctx_r1.data.url, ɵngcc0.ɵɵsanitizeUrl)("target", ctx_r1.data.target);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r1.data.text, " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.data.icon && ctx_r1.data.icon.src && ctx_r1.data.icon.alt);
} }
function CircleIconButtonComponent_div_0_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "a");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r3.data.text);
} }
function CircleIconButtonComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵtemplate(1, CircleIconButtonComponent_div_0_a_1_Template, 3, 4, "a", 2);
    ɵngcc0.ɵɵtemplate(2, CircleIconButtonComponent_div_0_ng_template_2_Template, 2, 1, "ng-template", null, 3, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const _r2 = ɵngcc0.ɵɵreference(3);
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(3, _c0, ctx_r0.data.colorType === "dark", ctx_r0.data.colorType === "green"));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.data.url && ctx_r0.data.target)("ngIfElse", _r2);
} }
function RectangleButtonComponent_div_0_a_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "a", 4);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("href", ctx_r1.data.url, ɵngcc0.ɵɵsanitizeUrl)("target", ctx_r1.data.target);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r1.data.text, " ");
} }
function RectangleButtonComponent_div_0_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "a");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r3.data.text);
} }
function RectangleButtonComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵtemplate(1, RectangleButtonComponent_div_0_a_1_Template, 2, 3, "a", 2);
    ɵngcc0.ɵɵtemplate(2, RectangleButtonComponent_div_0_ng_template_2_Template, 2, 1, "ng-template", null, 3, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const _r2 = ɵngcc0.ɵɵreference(3);
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(3, _c0, ctx_r0.data.colorType === "dark", ctx_r0.data.colorType === "green"));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.data.url && ctx_r0.data.target)("ngIfElse", _r2);
} }
class LliButtonsService {
    constructor() { }
}
LliButtonsService.ɵfac = function LliButtonsService_Factory(t) { return new (t || LliButtonsService)(); };
LliButtonsService.ɵprov = i0.ɵɵdefineInjectable({ factory: function LliButtonsService_Factory() { return new LliButtonsService(); }, token: LliButtonsService, providedIn: "root" });
LliButtonsService.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LliButtonsService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

class LliButtonsComponent {
    constructor() {
    }
    ngOnInit() {
    }
}
LliButtonsComponent.ɵfac = function LliButtonsComponent_Factory(t) { return new (t || LliButtonsComponent)(); };
LliButtonsComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: LliButtonsComponent, selectors: [["lib-buttons"]], inputs: { buttonType: "buttonType", buttonItem: "buttonItem" }, decls: 3, vars: 3, consts: [[3, "data", 4, "ngIf"], [3, "data"]], template: function LliButtonsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, LliButtonsComponent_lib_rectangle_button_0_Template, 1, 1, "lib-rectangle-button", 0);
        ɵngcc0.ɵɵtemplate(1, LliButtonsComponent_lib_circle_button_1_Template, 1, 1, "lib-circle-button", 0);
        ɵngcc0.ɵɵtemplate(2, LliButtonsComponent_lib_circle_icon_button_2_Template, 1, 1, "lib-circle-icon-button", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.buttonType === "rectangle" && ctx.buttonItem);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.buttonType === "circle" && ctx.buttonItem);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.buttonType === "circle-icon" && ctx.buttonItem);
    } }, directives: function () { return [ɵngcc1.NgIf, RectangleButtonComponent, CircleButtonComponent, CircleIconButtonComponent]; }, encapsulation: 2 });
LliButtonsComponent.ctorParameters = () => [];
LliButtonsComponent.propDecorators = {
    buttonType: [{ type: Input }],
    buttonItem: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LliButtonsComponent, [{
        type: Component,
        args: [{
                selector: 'lib-buttons',
                template: "<lib-rectangle-button *ngIf=\"buttonType === 'rectangle' && buttonItem\" [data]=\"buttonItem\"></lib-rectangle-button>\r\n<lib-circle-button *ngIf=\"buttonType === 'circle' && buttonItem\" [data]=\"buttonItem\"></lib-circle-button>\r\n<lib-circle-icon-button *ngIf=\"buttonType === 'circle-icon' && buttonItem\" [data]=\"buttonItem\"></lib-circle-icon-button>"
            }]
    }], function () { return []; }, { buttonType: [{
            type: Input
        }], buttonItem: [{
            type: Input
        }] }); })();

class CircleButtonComponent {
    constructor() { }
    ngOnInit() {
    }
}
CircleButtonComponent.ɵfac = function CircleButtonComponent_Factory(t) { return new (t || CircleButtonComponent)(); };
CircleButtonComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: CircleButtonComponent, selectors: [["lib-circle-button"]], inputs: { data: "data" }, decls: 1, vars: 1, consts: [["class", "circle-button", 3, "ngClass", 4, "ngIf"], [1, "circle-button", 3, "ngClass"], [3, "href", "target", 4, "ngIf", "ngIfElse"], ["displayText", ""], [3, "href", "target"]], template: function CircleButtonComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, CircleButtonComponent_div_0_Template, 4, 6, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.data);
    } }, directives: [ɵngcc1.NgIf, ɵngcc1.NgClass], styles: ["[_nghost-%COMP%]{letter-spacing:1.75;font-family:Arial,Helvetica,sans-serif;text-transform:uppercase;margin:0}[_nghost-%COMP%]   a[_ngcontent-%COMP%]{font-size:14px;text-decoration:none}[_nghost-%COMP%]   .circle-button[_ngcontent-%COMP%]{cursor:pointer;display:flex;align-items:center;justify-content:center;max-width:155px;height:50px;border-radius:25px;border:solid 1px #dddddd}[_nghost-%COMP%]   .dark[_ngcontent-%COMP%]{border:1px solid #000;background-color:#fff}[_nghost-%COMP%]   .dark[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{color:#000}[_nghost-%COMP%]   .green[_ngcontent-%COMP%]{border:1px solid #006d7a;background-color:#fff}[_nghost-%COMP%]   .green[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{color:#006d7a}"] });
CircleButtonComponent.ctorParameters = () => [];
CircleButtonComponent.propDecorators = {
    data: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CircleButtonComponent, [{
        type: Component,
        args: [{
                selector: 'lib-circle-button',
                template: "<div class=\"circle-button\" *ngIf=\"data\"\r\n    [ngClass]=\"{'dark': data.colorType === 'dark', 'green': data.colorType === 'green'}\"\r\n>\r\n    <a *ngIf=\"data.url && data.target; else displayText\" [href]=\"data.url\" [target]=\"data.target\">\r\n        {{ data.text }}\r\n    </a>\r\n    <ng-template #displayText>\r\n        <a>{{ data.text }}</a>\r\n    </ng-template>\r\n</div>\r\n\r\n",
                styles: [":host{letter-spacing:1.75;font-family:Arial,Helvetica,sans-serif;text-transform:uppercase;margin:0}:host a{font-size:14px;text-decoration:none}:host .circle-button{cursor:pointer;display:flex;align-items:center;justify-content:center;max-width:155px;height:50px;border-radius:25px;border:solid 1px #dddddd}:host .dark{border:1px solid #000;background-color:#fff}:host .dark a{color:#000}:host .green{border:1px solid #006d7a;background-color:#fff}:host .green a{color:#006d7a}\n"]
            }]
    }], function () { return []; }, { data: [{
            type: Input
        }] }); })();

class CircleIconButtonComponent {
    constructor() { }
    ngOnInit() {
    }
}
CircleIconButtonComponent.ɵfac = function CircleIconButtonComponent_Factory(t) { return new (t || CircleIconButtonComponent)(); };
CircleIconButtonComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: CircleIconButtonComponent, selectors: [["lib-circle-icon-button"]], inputs: { data: "data" }, decls: 1, vars: 1, consts: [["class", "circle-button", 3, "ngClass", 4, "ngIf"], [1, "circle-button", 3, "ngClass"], [3, "href", "target", 4, "ngIf", "ngIfElse"], ["displayText", ""], [3, "href", "target"], [3, "src", "alt", 4, "ngIf"], [3, "src", "alt"]], template: function CircleIconButtonComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, CircleIconButtonComponent_div_0_Template, 4, 6, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.data);
    } }, directives: [ɵngcc1.NgIf, ɵngcc1.NgClass], styles: ["[_nghost-%COMP%]{letter-spacing:1.75;font-family:Arial,Helvetica,sans-serif;text-transform:uppercase;margin:0}[_nghost-%COMP%]   a[_ngcontent-%COMP%]{font-size:14px;text-decoration:none}[_nghost-%COMP%]   .circle-button[_ngcontent-%COMP%]{cursor:pointer;display:flex;align-items:center;justify-content:center;max-width:155px;height:50px;border-radius:25px;border:solid 1px #dddddd}[_nghost-%COMP%]   .circle-button[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{display:flex;align-items:center;justify-content:center}[_nghost-%COMP%]   .circle-button[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{margin-left:10px;height:20px;width:20px}[_nghost-%COMP%]   .dark[_ngcontent-%COMP%]{border:1px solid #000;background-color:#fff}[_nghost-%COMP%]   .dark[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{color:#000}[_nghost-%COMP%]   .green[_ngcontent-%COMP%]{border:1px solid #006d7a;background-color:#fff}[_nghost-%COMP%]   .green[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{color:#006d7a}"] });
CircleIconButtonComponent.ctorParameters = () => [];
CircleIconButtonComponent.propDecorators = {
    data: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CircleIconButtonComponent, [{
        type: Component,
        args: [{
                selector: 'lib-circle-icon-button',
                template: "<div class=\"circle-button\" *ngIf=\"data\"\r\n    [ngClass]=\"{'dark': data.colorType === 'dark', 'green': data.colorType === 'green'}\"\r\n>\r\n    <a *ngIf=\"data.url && data.target; else displayText\" [href]=\"data.url\" [target]=\"data.target\">\r\n        {{ data.text }}\r\n        <img *ngIf=\"data.icon && data.icon.src && data.icon.alt\" [src]=\"data.icon.src\" [alt]=\"data.icon.alt\">\r\n    </a>\r\n    <ng-template #displayText>\r\n        <a>{{ data.text }}</a>\r\n    </ng-template>\r\n</div>\r\n\r\n",
                styles: [":host{letter-spacing:1.75;font-family:Arial,Helvetica,sans-serif;text-transform:uppercase;margin:0}:host a{font-size:14px;text-decoration:none}:host .circle-button{cursor:pointer;display:flex;align-items:center;justify-content:center;max-width:155px;height:50px;border-radius:25px;border:solid 1px #dddddd}:host .circle-button a{display:flex;align-items:center;justify-content:center}:host .circle-button a img{margin-left:10px;height:20px;width:20px}:host .dark{border:1px solid #000;background-color:#fff}:host .dark a{color:#000}:host .green{border:1px solid #006d7a;background-color:#fff}:host .green a{color:#006d7a}\n"]
            }]
    }], function () { return []; }, { data: [{
            type: Input
        }] }); })();

class RectangleButtonComponent {
    constructor() { }
    ngOnInit() {
    }
}
RectangleButtonComponent.ɵfac = function RectangleButtonComponent_Factory(t) { return new (t || RectangleButtonComponent)(); };
RectangleButtonComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: RectangleButtonComponent, selectors: [["lib-rectangle-button"]], inputs: { data: "data" }, decls: 1, vars: 1, consts: [["class", "rectangle-button", 3, "ngClass", 4, "ngIf"], [1, "rectangle-button", 3, "ngClass"], [3, "href", "target", 4, "ngIf", "ngIfElse"], ["displayText", ""], [3, "href", "target"]], template: function RectangleButtonComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, RectangleButtonComponent_div_0_Template, 4, 6, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.data);
    } }, directives: [ɵngcc1.NgIf, ɵngcc1.NgClass], styles: ["[_nghost-%COMP%]{letter-spacing:1.75;font-family:Arial,Helvetica,sans-serif;text-transform:uppercase;margin:0}[_nghost-%COMP%]   a[_ngcontent-%COMP%]{font-size:14px;text-decoration:none}[_nghost-%COMP%]   .rectangle-button[_ngcontent-%COMP%]{cursor:pointer;display:flex;align-items:center;justify-content:center;max-width:300px;height:50px;margin:auto;width:100%}[_nghost-%COMP%]   .dark[_ngcontent-%COMP%]{border:1px solid #000;background-color:#fff}[_nghost-%COMP%]   .dark[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{color:#000}[_nghost-%COMP%]   .green[_ngcontent-%COMP%]{border:1px solid #006d7a;background-color:#fff}[_nghost-%COMP%]   .green[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{color:#006d7a}"] });
RectangleButtonComponent.ctorParameters = () => [];
RectangleButtonComponent.propDecorators = {
    data: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(RectangleButtonComponent, [{
        type: Component,
        args: [{
                selector: 'lib-rectangle-button',
                template: "<div class=\"rectangle-button\" *ngIf=\"data\"\r\n    [ngClass]=\"{'dark': data.colorType === 'dark', 'green': data.colorType === 'green'}\"\r\n>\r\n    <a *ngIf=\"data.url && data.target; else displayText\" [href]=\"data.url\" [target]=\"data.target\">\r\n        {{ data.text }}\r\n    </a>\r\n    <ng-template #displayText>\r\n        <a>{{ data.text }}</a>\r\n    </ng-template>\r\n</div>\r\n\r\n",
                styles: [":host{letter-spacing:1.75;font-family:Arial,Helvetica,sans-serif;text-transform:uppercase;margin:0}:host a{font-size:14px;text-decoration:none}:host .rectangle-button{cursor:pointer;display:flex;align-items:center;justify-content:center;max-width:300px;height:50px;margin:auto;width:100%}:host .dark{border:1px solid #000;background-color:#fff}:host .dark a{color:#000}:host .green{border:1px solid #006d7a;background-color:#fff}:host .green a{color:#006d7a}\n"]
            }]
    }], function () { return []; }, { data: [{
            type: Input
        }] }); })();

const components = [
    LliButtonsComponent,
    RectangleButtonComponent,
    CircleButtonComponent,
    CircleIconButtonComponent,
];
class LliButtonsModule {
}
LliButtonsModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: LliButtonsModule });
LliButtonsModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function LliButtonsModule_Factory(t) { return new (t || LliButtonsModule)(); }, imports: [[
            CommonModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(LliButtonsModule, { declarations: function () { return [LliButtonsComponent, RectangleButtonComponent, CircleButtonComponent, CircleIconButtonComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [LliButtonsComponent, RectangleButtonComponent, CircleButtonComponent, CircleIconButtonComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LliButtonsModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    ...components
                ],
                imports: [
                    CommonModule,
                ],
                exports: [
                    ...components
                ]
            }]
    }], null, null); })();

/*
 * Public API Surface of buttons
 */

/**
 * Generated bundle index. Do not edit.
 */

export { LliButtonsComponent, LliButtonsModule, LliButtonsService, RectangleButtonComponent as ɵa, CircleButtonComponent as ɵb, CircleIconButtonComponent as ɵc };

//# sourceMappingURL=scoop-lli-buttons.js.map